<template>
  <div class="content" style="height:100%;">
    <td >
<!--      <img class :src="defaultCoverUrl" style="width:30%;display:block" />-->
      <!-- <img class="" src="../../assets/images/logo.png" style="width: 23%;position: absolute;top: -12px;left: 11px;z-index: 2;"/> -->
    </td>
    <!-- <img class="banner" src="../../assets/images/banner.png" /> -->

    <div class="card">
      <div class="footer-top" style="height:35px;"></div>
      <img class="success" src="../../assets/images/success.png" />
      <div class="footer">提交成功</div>
      <div v-if="source === 'H5' || source === 'erbaoweixueyuan'" class="footer">{{ count }}s后将自动跳转...</div>
    </div>
  </div>
</template>

<script>
import API from '@/api/common';
export default {
  name: "success",
  data() {
    return {
      openid: this.$route.query.openid,
      examId: this.$route.query.examId,
      source: this.$route.query.source,
      count: '',//倒计时
      h5url: process.env.VUE_APP_H5_URL,
      erbaoweixueyuanUrl: process.env.VUE_APP_ERBAOWEIXUEYUAN_URL,
      coverUrl: '',
      defaultCoverUrl: require('../../assets/images/logo_ch.png')
    }
  },
  created() {
    if(this.source === 'H5') {
      this.threeGo(this.h5url)
    } else if(this.source === 'erbaoweixueyuan') {
      this.threeGo(this.erbaoweixueyuanUrl)
    } 
  },
  methods: {
    init() {

    },
    //3秒后进入跳转页面
    threeGo(url){
      const TIME_COUNT = 3;
      if(!this.timer){
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(()=>{
        if(this.count > 0 && this.count <= TIME_COUNT){
          this.count--;
        }else{
          this.show = true;
          clearInterval(this.timer);
          this.timer = null;
          //跳转的页面写在此处
          window.location.href = url
          // window.location.href = 'https://www.baidu.com'
        }
        },1000)
      }
    }
  }
  
};
</script>

<style lang="less" scoped>
.content {
  background-color: #fff;
  .banner {
    width: 100%;
    height: auto;
  }

  .card {
    position: relative;
    // top: -175px;
    // width: 90%;
    margin-bottom: 30px;
    height: 60vh;
    margin: 0 auto;
    border-radius: 6px;

    .title {
      display: inline-block;
      font-size: 18px;
      font-weight: bold;
      text-align: center;
      width: 100%;
      margin: 20px auto;
    }

    .success {
      display: block;
      width: 50%;
      height: auto;
      margin: 40px auto;
    }

    .footer {
      font-size: 20px;
      font-weight: bold;
      text-align: center;
    }
  }
}
</style>
